import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_PROMOTED_PRODUCT} from "../../../utils/input-field-list-static-page";
import {
    setBeautyFridayErrorMessage,
    setBeautyFridayPromotedProductDetail
} from "../../../reducers/beauty-friday.reducer";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import React, {useEffect} from "react";
import ItemPromotedProduct from "./item-promoted-product";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {cloneDeep} from "lodash";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import FormItemComponent from "../../../components/static-page/form-item.component";

const PromotedProduct = () => {
    const dispatch = useDispatch()
    const {promotedProductDetail} = useSelector(state => state.beautyFridayReducer)
    const {fetching: getPromotedProduct} = useFetch(API.BF_GET_PROMOTED_PRODUCT)
    const {fetching: updatePromotedProduct, isLoading} = useFetch(API.BF_UPDATE_PROMOTED_PRODUCT)
    const itemList = [...promotedProductDetail.item_list]
    let fieldList = FIELD_LIST_PROMOTED_PRODUCT
    let showPromotedProduct = {
        label: 'Promoted Product',
        key: 'show_promoted_product',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setBeautyFridayPromotedProductDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'promoted_product').toString(),
            product_image: null,
            link_product: null
        })
        dispatch(setBeautyFridayPromotedProductDetail({item_list: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(promotedProductDetail.item_list)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataPromotedProduct = {...promotedProductDetail, item_list: dataItemList}
        updatePromotedProduct(dataPromotedProduct).then(response => {
            dispatch(setBeautyFridayErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Promoted Product Updated'))
            dispatch(setBeautyFridayPromotedProductDetail({...response?.data, delete_ids: []}))
        }).catch(err => {
            dispatch(setBeautyFridayErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getPromotedProduct().then(response => {
            if (response?.data?.item_list?.length > 0) {
                dispatch(setBeautyFridayPromotedProductDetail({...response?.data, delete_ids: []}))
            } else {
                const data = response?.data
                delete data?.item_list
                dispatch(setBeautyFridayPromotedProductDetail({...data, delete_ids: []}))
            }
        })

        return () => {
            dispatch(setBeautyFridayErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={promotedProductDetail}
            title={'Product'}
            switchToggleField={showPromotedProduct}
            itemList={itemList}
            content={(index) => <ItemPromotedProduct fieldList={fieldList} index={index}/>}
            onChange={onChange}
            setDataList={setBeautyFridayPromotedProductDetail}
            deleteList={promotedProductDetail?.delete_ids}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            isLoading={isLoading}
        />
    )
}

export default PromotedProduct
